<template>
  <div>
    <v-card class="elevation-0">
      <v-toolbar card dense color="transparent">
        <v-toolbar-title><h5>Notification</h5></v-toolbar-title>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text class="pa-0">
        <v-list two-line class="pa-0">
          <template v-for="(item, index) in items">
            <v-subheader v-if="item.header" :key="item.header">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider" :key="index"></v-divider>
            <v-list-tile avatar v-else :key="item.brokeredBy" @click="handleClick">
              <v-list-tile-avatar :color="item.color">
                <v-icon dark>{{item.icon}}</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-sub-title><b>{{item.perantara}}</b> (Perantara) dari <b>{{item.entitasPerantara}}</b></v-list-tile-sub-title>
                <v-divider></v-divider>
                <v-list-tile-sub-title><b>{{item.kodePenjualan}}</b>
                </v-list-tile-sub-title>
                <v-divider></v-divider>
                <v-list-tile-sub-title><b>{{item.komoditas}}</b> | <b>Rp {{item.harga}},00</b>
                </v-list-tile-sub-title>
                <v-divider></v-divider>
              </v-list-tile-content>
              <br>
              <v-list-tile-action class="caption">
                {{item.timeLabel}}
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
        <v-divider></v-divider>
        <v-btn block flat class="ma-0">All</v-btn>
        <v-divider></v-divider>
      </v-card-text>
      
    </v-card>
  </div>
</template>

<script>
import notes from '@/api/notificationPerusahaan';
export default {
  data: () => ({
    items: notes
  }),
  methods: {
    handleClick: (e) => {
      window.getApp.$emit('APP_KOMODITAS');
    }
  },

};
</script>

<style scoped>
</style>
